import {
  Typography,
  Card,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid as Grid2,
  Divider,
  Grid,
  Tooltip,
  Button,
} from "@mui/material";
import { formatAge } from "../Utility/Utility";
import PrescriptionView from "./PrescriptionView";
import GeneralPrescriptionReadOnlyView from "./GeneralPrescriptionReadOnlyView";
import PhysiotherapyPrescriptionReadOnly from "./PhysiotherapyPrescriptionReadOnly";
import FollowUpNotes from "./FollowUpNotes";
import { useSnackbar } from "../Utility/UserMessageContext";
import AuthContext from "../Context/AuthProvider";
import { useContext } from "react";
import { viewPrescriptionById } from "../API/PrescriptionApi";
import { PrescriptionTypes } from "../Utility/Constants";

function PrescriptionReadOnlyView({ prescriptionId, prescriptionType }) {
  const { showSnackbar } = useSnackbar();
  const { auth } = useContext(AuthContext);

  const viewPrescription = async () => {
    try {
      if (auth != null && prescriptionId != null) {
        await viewPrescriptionById(auth, prescriptionId);
      }
    } catch (error) {
      showSnackbar("Error viewing prescription: " + error.message, "error");
    } finally {
    }
  };
  return (
    <Grid2
      container
      spacing={2}
      sx={{ maxHeight: "90vh", overflowY: "auto", pt: 1, pl: 1, pr: 1 }}
      size={12}
    >
      <Grid2 item xs={12}>
        <Tooltip title="Download as PDF">
          <Button
            variant="contained"
            size="small"
            color="secondary"
            onClick={viewPrescription}
            >
            Download
          </Button>
        </Tooltip>
      </Grid2>
      <Grid2 item xs={8}>
        {prescriptionId && prescriptionType === PrescriptionTypes.GeneralPrescription && (
          <GeneralPrescriptionReadOnlyView prescriptionId={prescriptionId} />
        )}
        {prescriptionId && prescriptionType === PrescriptionTypes.PhysiotherapyPrescription && (
          <PhysiotherapyPrescriptionReadOnly prescriptionId={prescriptionId} />
        )}
      </Grid2>
      <Grid2 item xs={4}>
        <FollowUpNotes
          documentId={prescriptionId}
          documentType="prescription"
        />
      </Grid2>
    </Grid2>
  );
}

export default PrescriptionReadOnlyView;
